import { render, staticRenderFns } from "./PopupInmarsat.vue?vue&type=template&id=38a5a68d"
import script from "./PopupInmarsat.vue?vue&type=script&lang=js"
export * from "./PopupInmarsat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports